import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useGoBack } from '@/common/hooks/useGoBack'
import { useDeleteGovernmentAllocation } from '@/features/privateCompanies/hooks/useDeleteGovernmentAllocation'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface DeleteGovernmentAllocationModalProps {
  companyId: string
  isOpen?: boolean
  setIsOpen: (value: boolean) => void
}

export const DeleteGovernmentAllocationModal = ({
  companyId,
  isOpen = false,
  setIsOpen,
}: DeleteGovernmentAllocationModalProps) => {
  const { id: governmentAllocationId } = useParams()
  const queryClient = useQueryClient()
  const goBack = useGoBack()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const {
    mutate: deleteGovernmentAllocation,
    isPending: deleteGovernmentAllocationIsPending,
    isError: deleteGovernmentAllocationIsError,
  } = useDeleteGovernmentAllocation({
    governmentAllocationId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['governmentAllocations', governmentAllocationId] })
      queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation', governmentAllocationId] })
      setIsOpen(false)
      goBack({ fallback: `/companies/${companyId}/government-allocation`, searchLastRouteFromFallback: true })
    },
    onError: (error) => {
      setIsOpen(false)

      if (error.response?.data.errors.base) {
        setMessages(error.response?.data.errors.base)
      } else {
        setMessages(['Erro ao excluir empenho. Tente novamente.'])
      }
    },
  })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        useCancellableFooter
        cancelButtonText="Cancelar"
        onConfirm={deleteGovernmentAllocation}
        onCancel={() => setIsOpen(false)}
        confirmButtonIsLoading={deleteGovernmentAllocationIsPending}
        disabled={deleteGovernmentAllocationIsPending}
        bodyClassName="bg-neutral-op-8"
        body={
          <div className="text-white-800 rounded-md">
            <h1 className="text-white-800 font-bold text-2xl mb-2">Confirmar exclusão</h1>
            <p className="mb-4">Tem certeza que deseja excluir este empenho? Esta ação não pode ser desfeita.</p>
          </div>
        }
      />

      {messages && (
        <ModalMessageSimple messages={messages} setMessages={setMessages} isError={deleteGovernmentAllocationIsError} />
      )}
    </>
  )
}
